import Cookies from 'universal-cookie';

var api_url_ = null;

const cookies = new Cookies();

export function init(base_url)
{
    // If base_url is empty string, use current origin (window.location.origin)
    // Otherwise use the provided URL or fall back to localhost
    if (base_url === '') {
        api_url_ = window.location.origin;
    } else {
        api_url_ = base_url || process.env.REACT_APP_BACKEND_URL || `http://localhost:${process.env.PORT_HTTP_HOST || '9011'}`;
    }

    // Log the API URL for debugging
    console.log('API URL initialized to:', api_url_);
}

// Helper function to get common headers with token
function getAuthHeaders(additionalHeaders = {}) {
    const token = get_token();
    return {
        'Authorization': token ? `Bearer ${token}` : undefined,
        ...additionalHeaders
    };
}

// Helper function to build API URL
function buildApiUrl(path) {
    // Ensure path starts with /api/
    if (!path.startsWith('/api/')) {
        path = '/api/' + path.replace(/^\/+/, '');
    }
    const url = api_url_ + path;
    console.log('Building API URL:', { path, result: url });
    return url;
}

// Helper function to build RSS URL
export function buildRssUrl(path) {
    const url = api_url_ + path;
    console.log('Building RSS URL:', { path, result: url });
    return url;
}

export function get_token() {
    const token = cookies.get('token');
    if (token === "undefined")
        return undefined;
    return token;
}

export function set_token(token) {
    cookies.set('token', token, { path: '/' });
}

export function add_token_listener(cb) {
    cookies.addChangeListener(cb);
}

export function post_auth_json(path, data, callback) {
    console.log('POST Auth:', buildApiUrl(path), data);
    return fetch(buildApiUrl(path), {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(resp => resp.json())
    .then(response => {
        console.log('POST Auth Response:', response);
        callback(response);
    })
    .catch(error => {
        console.error('POST Auth Error:', error);
        callback({ error: error.message });
    });
}

export function get_json(path, callback) {
    console.log('GET:', buildApiUrl(path));
    return fetch(buildApiUrl(path), {
        headers: getAuthHeaders()
    })
    .then(resp => resp.json())
    .then(response => {
        console.log('GET Response:', response);
        callback(response);
    })
    .catch(error => {
        console.error('GET Error:', error);
        callback({ error: error.message });
    });
}

export function delete_json(path, callback) {
    console.log('DELETE:', buildApiUrl(path));
    return fetch(buildApiUrl(path), {
        method: "DELETE",
        headers: getAuthHeaders()
    })
    .then(resp => resp.json())
    .then(response => {
        console.log('DELETE Response:', response);
        callback(response);
    })
    .catch(error => {
        console.error('DELETE Error:', error);
        callback({ error: error.message });
    });
}

export function post_json(path, data, callback) {
    console.log('POST:', buildApiUrl(path), data);
    return fetch(buildApiUrl(path), {
        method: "POST",
        headers: getAuthHeaders({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(data)
    })
    .then(resp => resp.json())
    .then(response => {
        console.log('POST Response:', response);
        callback(response);
    })
    .catch(error => {
        console.error('POST Error:', error);
        callback({ error: error.message });
    });
}
